import Input from "@components/Input"
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline"
import { useState } from "react"
import { useTranslation } from "react-i18next"

interface Props {
  autoComplete?: "current-password" | "new-password"
  autoFocus?: boolean
  disabled?: boolean
  invalid?: boolean
  name?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  value?: string
}

export default function PasswordInput({
  autoComplete,
  autoFocus = false,
  disabled = false,
  invalid = false,
  name,
  onChange,
  value,
}: Props) {
  const [isVisible, setIsVisible] = useState(false)

  const { t } = useTranslation()

  return (
    <div className="relative">
      <Input
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        className="pr-12"
        disabled={disabled}
        invalid={invalid}
        name={name}
        onChange={onChange}
        placeholder={t("shared.password")}
        type={isVisible ? "text" : "password"}
        value={value}
      />

      <button
        aria-label={t("pages.onboarding.password.toggleVisibility")}
        aria-pressed={isVisible}
        className="absolute right-3 top-1/2 -translate-y-1/2 rounded-md p-1 text-vm-muted transition-colors hover:text-vm-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-vm-primary/40 disabled:opacity-40"
        disabled={disabled}
        onClick={() => setIsVisible((current) => !current)}
        type="button"
      >
        {isVisible ? (
          <EyeSlashIcon className="h-5 w-5" />
        ) : (
          <EyeIcon className="h-5 w-5" />
        )}
      </button>
    </div>
  )
}
